/* Prom Dollz — designer size charts with Fit Finder, and made-to-order options (Doll House). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };

  /* ---------------- Size chart + Fit Finder ---------------- */
  var modal = $('#SizeChartModal');
  var chart = null;
  if (modal) {
    try { chart = JSON.parse($('[data-sc-json]', modal).textContent); } catch (e) { chart = null; }
  }
  var ROWS = [['bust', 'Bust'], ['waist', 'Waist'], ['hips', 'Hips']];
  function fmt(n) { return (Math.round(n * 100) / 100).toString(); }

  if (chart) {
    $('[data-sc-label]', modal).textContent = 'Published chart for ' + chart.label + (chart.note ? '. ' + chart.note : '');
    var t = $('[data-sc-table]', modal);
    var h = '<thead><tr><th scope="row">Size</th>' + chart.sizes.map(function (s) { return '<th scope="col">' + s + '</th>'; }).join('') + '</tr></thead><tbody>';
    ROWS.forEach(function (r) {
      h += '<tr><th scope="row">' + r[1] + '</th>' + chart[r[0]].map(function (v) { return '<td>' + fmt(v) + '</td>'; }).join('') + '</tr>';
    });
    t.innerHTML = h + '</tbody>';

    // Open our chart instead of the generic size-guide page (runs before the theme's own click handler).
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-size-guide]');
      if (!a || a.closest('#QuickView')) return;
      e.preventDefault(); e.stopPropagation();
      PD.openLayer(modal, a);
    }, true);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) PD.closeLayer(modal); });

    // Fit finder: smallest size whose chart measurement is >= every measurement entered.
    $('[data-sc-form]', modal).addEventListener('submit', function (e) {
      e.preventDefault();
      var f = e.target, given = {}, out = $('[data-sc-result]', modal);
      ROWS.forEach(function (r) { var v = parseFloat(f.elements[r[0]].value); if (v > 0) given[r[0]] = v; });
      var keys = Object.keys(given);
      [].forEach.call(modal.querySelectorAll('.sc__table .is-pick'), function (c) { c.classList.remove('is-pick'); });
      if (!keys.length) { out.innerHTML = '<p>Enter at least one measurement.</p>'; return; }
      var n = chart.sizes.length, idx = -1, driver = '';
      keys.forEach(function (k) {
        var i = 0; while (i < n && chart[k][i] < given[k]) i++;
        if (i >= n) i = n; // larger than the chart
        if (i > idx) { idx = i; driver = k; }
      });
      if (idx >= n) {
        out.innerHTML = '<p><strong>Your measurements are larger than this chart.</strong> Book an appointment or ask about special order sizing and our stylists will help.</p>';
        return;
      }
      var size = chart.sizes[idx];
      var col = idx + 2;
      [].forEach.call(modal.querySelectorAll('.sc__table tr > :nth-child(' + col + ')'), function (c) { c.classList.add('is-pick'); });
      var mixed = keys.length > 1 && keys.some(function (k) { var j = 0; while (j < n && chart[k][j] < given[k]) j++; return j !== idx; });
      out.innerHTML = '<p class="sc__pick">Suggested size: <strong>' + size + '</strong></p>' +
        (mixed ? '<p class="fine">Your measurements fall across different sizes. We’ve suggested the size that fits your ' + (driver === 'hips' ? 'hips' : driver) + ', so the dress can be tailored down elsewhere.</p>' : '') +
        '<button type="button" class="btn btn--outline btn--sm" data-sc-apply="' + size + '">Select size ' + size + '</button>';
    });
    modal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sc-apply]'); if (!b) return;
      var size = b.getAttribute('data-sc-apply');
      var input = document.querySelector('[data-size-grid] input[value="' + size.replace(/"/g, '\\"') + '"]');
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      PD.closeLayer(modal);
    });
  }

  /* ---------------- Made-to-order options ---------------- */
  var mto = $('[data-mto]');
  if (!mto) return;
  var form = mto.closest('[data-product-form]');
  if (!form) return;
  var btnPrice = form.querySelector('[data-btn-price]');
  var dateIn = $('[data-mto-date]', mto), warn = $('[data-mto-warn]', mto);
  var today = new Date(); today.setHours(0, 0, 0, 0);
  dateIn.min = today.toISOString().slice(0, 10);

  function val(name) { var c = form.querySelector('input[name="' + name + '"]:checked'); return c ? c.value : ''; }
  var isLong = function () { return val('mto-length') !== 'Standard'; };
  var isRush = function () { return val('mto-production').indexOf('Rush') === 0; };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };

  function basePrice() {
    var id = +form.querySelector('[data-variant-id]').value;
    var json = document.querySelector('script[data-product-json]');
    if (!json) return 0;
    var d = JSON.parse(json.textContent);
    var v = (d.variants || []).filter(function (x) { return x.id === id; })[0];
    return v ? v.price : 0;
  }
  function refresh() {
    var extra = (isLong() ? +mto.dataset.lengthPrice : 0) + (isRush() ? +mto.dataset.rushPrice : 0);
    if (btnPrice) setTimeout(function () { var b = basePrice(); if (b) btnPrice.textContent = money(b + extra); }, 0);
    // Warn when the event is sooner than the chosen production time allows
    warn.hidden = true;
    if (dateIn.value) {
      var ev = new Date(dateIn.value + 'T00:00:00');
      var weeks = Math.floor((ev - today) / (7 * 864e5));
      var need = isRush() ? 8 : 12;
      if (weeks < need) {
        warn.hidden = false;
        warn.textContent = isRush()
          ? 'Your event is ' + weeks + ' weeks away. Rush production takes 6–8 weeks, so please call us to confirm timing before ordering.'
          : 'Your event is ' + weeks + ' weeks away. Standard production takes 10–12 weeks. Choose rush production or call us to confirm timing.';
      }
    }
  }
  form.addEventListener('change', function (e) {
    if (e.target.name === 'mto-size') { var l = $('[data-mto-size-label]', mto); if (l) l.textContent = e.target.value; }
    refresh();
  });
  dateIn.addEventListener('input', refresh);
  refresh();

  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    e.preventDefault(); e.stopPropagation();
    var id = +form.querySelector('[data-variant-id]').value;
    if (!id) return;
    var size = val('mto-size');
    if (!size) { var g = mto.querySelector('[data-size-grid]'); g && g.scrollIntoView({ block: 'center', behavior: 'smooth' }); PD.toast && PD.toast('Please choose a size'); return; }
    if (!dateIn.value) { dateIn.focus(); dateIn.reportValidity && dateIn.reportValidity(); PD.toast && PD.toast('Please enter your event wear date'); return; }
    var btn = form.querySelector('[data-add-btn]');
    var title = (document.querySelector('.pdp__title') || {}).textContent || '';
    var opts = [].map.call(form.querySelectorAll('[data-option]:checked, select[data-option]'), function (x) { return x.value; }).join(' / ');
    var props = { 'Size': size, 'Dress length': val('mto-length'), 'Event wear date': dateIn.value, 'Production time': val('mto-production') };
    var items = [{ id: id, quantity: 1, properties: props }];
    var forDress = (title.trim() + ' – ' + opts + ' / Size ' + size).trim();
    if (isLong()) items.push({ id: +mto.dataset.lengthVariant, quantity: 1, properties: { 'For': forDress } });
    if (isRush()) items.push({ id: +mto.dataset.rushVariant, quantity: 1, properties: { 'For': forDress } });
    var gbag = form.querySelector('[data-pdp-garment]');
    if (gbag && gbag.checked) items.push({ id: +gbag.value, quantity: 1, properties: { 'For': forDress } });
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(PD.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) throw new Error(res.description);
      var html = res.sections && res.sections['cart-drawer'];
      if (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__panel');
        var cur = document.querySelector('#CartDrawer .drawer__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      return fetch(PD.routes.cart + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count > 0 ? cart.item_count : ''; c.setAttribute('data-count', cart.item_count); });
      PD.openLayer(document.getElementById('CartDrawer'));
    }).catch(function (err) { PD.toast && PD.toast(err.message || 'Could not add to bag'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }, true);
})();

/* ---------------- Garment bag add-on (bag drawer) ---------------- */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-garment]');
    if (!cb) return;
    cb.disabled = true;
    var req = cb.checked
      ? fetch(PD.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +cb.dataset.garment, quantity: 1 }], sections: 'cart-drawer' }) })
      : fetch(PD.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: cb.dataset.garmentKey, quantity: 0, sections: 'cart-drawer' }) });
    req.then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) throw new Error(res.description);
      if (cb.hasAttribute('data-garment-reload')) { location.reload(); return null; } // cart page: redraw totals
      var html = res.sections && res.sections['cart-drawer'];
      if (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__panel');
        var cur = document.querySelector('#CartDrawer .drawer__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      return fetch(PD.routes.cart + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (!cart) return;
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count > 0 ? cart.item_count : ''; c.setAttribute('data-count', cart.item_count); });
    }).catch(function (err) { cb.checked = !cb.checked; cb.disabled = false; PD.toast && PD.toast(err.message || 'Could not update your bag'); });
  });
})();

/* ---------------- Garment bag on the product page ----------------
   When "Add a garment bag" is ticked, the dress and the bag go into the bag in ONE request
   (two separate adds can race and drop one). Runs in the capture phase so it replaces the
   theme's own add for that click; made-to-order forms add the bag in their own handler above. */
(function () {
  'use strict';
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]') || form.querySelector('[data-mto]')) return;
    var box = form.querySelector('[data-pdp-garment]');
    if (!box || !box.checked) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var id = +(form.querySelector('[data-variant-id]') || {}).value;
    if (!id) return;
    var btn = form.querySelector('[data-add-btn]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(PD.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }, { id: +box.value, quantity: 1 }], sections: 'cart-drawer', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) throw new Error(res.description);
      var html = res.sections && res.sections['cart-drawer'];
      if (html && PD.cart && PD.cart.renderDrawer) PD.cart.renderDrawer(html);
      box.checked = false;
      return fetch(PD.routes.cart + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (PD.cart && PD.cart.setCount) PD.cart.setCount(cart.item_count);
      else document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count > 0 ? cart.item_count : ''; c.setAttribute('data-count', cart.item_count); });
      var qv = document.getElementById('QuickView'); if (qv && !qv.hidden && PD.closeLayer) PD.closeLayer(qv);
      PD.openLayer(document.getElementById('CartDrawer'));
    }).catch(function (err) { PD.toast && PD.toast(err.message || 'Could not add to bag'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }, true);
})();

/* Prom Dollz — product gallery: photo zoom + videos. */
(function () {
  'use strict';
  // Photo zoom: open the photo that was clicked, whatever order the slides are in
  // (a video among the photos, or a color moved to the front on desktop).
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lightbox-open]');
    if (!b) return;
    var root = b.closest('[data-product-root]'); var im = b.querySelector('img');
    if (!root || !im) return;
    var i = [].indexOf.call(root.querySelectorAll('.gallery__slide img'), im);
    if (i > -1) b.setAttribute('data-lightbox-open', i);
  }, true);

  // Gallery videos are silent loops: play while on screen, pause when scrolled or swiped away.
  var vids = document.querySelectorAll('.gallery__slide video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.5 });
  [].forEach.call(vids, function (v) { v.muted = true; io.observe(v); });
})();

/* ---------------- Bridal-mini tiles: silent video while on screen ----------------
   The video file is only fetched once the tile scrolls into view, and it pauses when it leaves.
   Uses the adaptive HLS stream where supported (small rendition on phones), else the MP4.
   Skipped for people who ask for reduced motion or data saving, and on 2G connections. Re-scans after filter/sort updates. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType || ''))) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (!v.src) {
          var hls = v.getAttribute('data-card-hls');
          v.src = (hls && v.canPlayType('application/vnd.apple.mpegurl')) ? hls : v.getAttribute('data-card-video');
        }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        v.classList.add('is-on');
      } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '150px 0px', threshold: 0.25 });
  function scan(root) { (root || document).querySelectorAll('video[data-card-video]:not([data-watched])').forEach(function (v) { v.setAttribute('data-watched', ''); io.observe(v); }); }
  scan();
  if ('MutationObserver' in window) new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
})();
